import styled from "styled-components";
import * as theme from "../../../../theme";

export const DemoBannerContainer = styled.div`
  height: auto;
  background-color: ${theme.palette.paleYellow};
  display: flex;
  width: 100%;
  align-items: center;
  padding: 12px 16px;

  .banner-content {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;

    .message {
      display: flex;
      align-items: center;
      gap: 12px;

      .header {
        color: ${theme.palette.gunmetal};
        line-height: 24px;
        font-weight: ${theme.font.mainFontWeight};
      }
    }
  }
`;

export const DialogText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  padding: 0px 40px;
  overflow: hidden;
  line-height: 20px;
`;
